import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const assignmentsSlice = createSlice({
  name: "assignments",
  initialState,
  reducers: {},
});

export const {} = assignmentsSlice.actions;
export default assignmentsSlice.reducer;
